



































import { Component, Vue } from 'vue-property-decorator';
import HeadLable from '@/components/HeadLable/index.vue';
import { addCompetition, queryCompetitionById, updateCompetition } from '@/api/competition.ts';
import { importPlayer } from '@/api/player.ts';
import { encrypt, decrypt } from '@/utils/crypto'

@Component({
  name: 'addCompetition',
  components: {
    HeadLable
  }
})
export default class extends Vue {
  private title = '导入选手';
  private title1 = '';
  private actionType = 'add';
  private titleId = '';
  private titleId1 = '';
  private srcMatch;
  private loading1 = 0
  private realnameMatch;
  private imgSrcRegex = /<td\b[^>]*\bclass="touxiang"[^>]*><img\b[^>]*\bsrc="([^"]+)"[^>]*>/g;
  private realnameRegex = /<td class="realname">([^<]+)<\/td>/g;
  private timeRegex     = /<td\b[^>]*\bclass="time"[^>]*>([^<]+)<\/td>/gi;
  private results = [];
  private ruleForm = {
    id: '', // 添加 id 字段，用于编辑时标识赛事
    content: ''
  };

  private rules = {
    content: [
      {
        required: true,
        message: '请输入公告内容',
        trigger: 'blur'
      }
    ]
  };

  created() {
    this.titleId1 = this.$route.query.titleId;
    if (this.$route.query.title) {
      this.title1 = this.$route.query.title
    }
    this.actionType = this.$route.query.id ? 'edit' : 'add';
    this.name()
    if (this.$route.query.id) {
      this.title = '修改公告信息';
      this.init();
    }
  }

  private name() {
    try {
      // 解密
      this.titleId = decrypt(this.$route.query.titleId as string)
    } catch (e) {
      console.error("解密失败:", e)
      // this.title = "默认标题"
    }
  }

  cancel() {
    this.$router.push({ path: '/competition/playerManage', query: { titleId: this.titleId1, title: this.title1 } })
  }

  private async init() {
    const params = {
      id: this.$route.query.id,
      type: 1
    };
    queryCompetitionById(params).then((res: any) => {
      if (res.data.code === 1) {
        this.ruleForm = {
          ...this.ruleForm,
          id: res.data.data.id, // 确保 id 被正确赋值
          content: res.data.data.content
        };
      } else {
        this.$message.error(res.data.msg);
      }
    });
  }

private formatChineseTimeToStandard(timeStr: string): string {
  // Example input: "2025年05月02日 20时01分"
  const matches = timeStr.match(/(\d{4})年(\d{2})月(\d{2})日 (\d{2})时(\d{2})分/);

  if (matches) {
    const [_, year, month, day, hour, minute] = matches;
    return `${year}-${month}-${day} ${hour}:${minute}:00`;
  }

  return timeStr; // Return original if format doesn't match
}

  private submitForm(continueAdd: boolean = false) {
    while ((this.srcMatch = this.imgSrcRegex.exec(this.ruleForm.content)) !== null) {
      const src = this.srcMatch[1];
      if ((this.realnameMatch = this.realnameRegex.exec(this.ruleForm.content)) !== null) {
        const realname = this.realnameMatch[1];
        // this.results.push({name: realname, photo: src});
        if ((this.timeMatch = this.timeRegex.exec(this.ruleForm.content)) !== null) {
          const originalTime = this.timeMatch[1];
          const time = this.formatChineseTimeToStandard(originalTime);
          this.results.push({
            name: realname,
            photo: src,
            time: time
          });
        }
      }
    }
    // 按 time 从早到晚排序
    this.results.sort((a, b) => {
      return new Date(a.time) - new Date(b.time);
    });
    console.log(this.results);
    const params = {
      titleId: this.titleId,
      results: this.results
    }
    this.loading1 = 1
    importPlayer(params)
      .then((res: any) => {
        this.loading1 = 0
        if (res.data.code === 1) {
                this.$message.success('导入成功！');
                if (!continueAdd) {
                  this.$router.push({ path: '/competition/playerManage', query: { titleId: this.titleId1, title: this.title1 } });
                } else {
                  this.ruleForm = {
                    content: ''
                  };
                }
              } else {
                this.$message.error(res.data.msg);
              }
      })
    // (this.$refs.ruleForm as any).validate((valid: boolean) => {
    //   if (valid) {
    //     const params = {
    //       id: this.ruleForm.id, // 添加 id 字段
    //       content: this.ruleForm.content,
    //       type: 1,
    //       titleId: this.titleId
    //     };

    //     if (this.actionType === 'add') {
    //       addCompetition(params)
    //         .then((res: any) => {
    //           if (res.data.code === 1) {
    //             this.$message.success('公告新建成功！');
    //             if (!continueAdd) {
    //               this.$router.push({ path: '/competition/noticeManage' });
    //             } else {
    //               this.ruleForm = {
    //                 content: ''
    //               };
    //             }
    //           } else {
    //             this.$message.error(res.data.msg);
    //           }
    //         })
    //         .catch(() => {
    //           this.$message.error('请求出错了');
    //         });
    //     } else if (this.actionType === 'edit') {
    //       delete params.titleId
    //       updateCompetition(params)
    //         .then((res: any) => {
    //           if (res.data.code === 1) {
    //             this.$message.success('公告修改成功！');
    //             this.$router.push({ path: '/competition/noticeManage' });
    //           } else {
    //             this.$message.error(res.data.msg);
    //           }
    //         })
    //         .catch(() => {
    //           this.$message.error('请求出错了');
    //         });
    //     }
    //   } else {
    //     this.$message.error('表单验证失败，请检查输入');
    //   }
    // });
  }
}
